import { render, staticRenderFns } from "./ImportHistoryPopup.vue?vue&type=template&id=081d1014&"
import script from "./ImportHistoryPopup.vue?vue&type=script&lang=js&"
export * from "./ImportHistoryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports